export const NAMES = {
  TAG_NAME: "ab-loader",
}
